export interface WpMedia {
    id;
    date;
    date_gmt;
    guid;
    modified_gmt;
    slug;
    type;
    link;
    title;
    author;
    comment_status;
    ping_status;
    alt_text;
    caption;
    description;
    media_type;
    mime_type;
    media_details;
    post;
    source_url;
    _links;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
